import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Fires a pixel PageView on every client-side route change (Meta + TikTok),
 * which don't auto-track SPA navigations. The initial PageView is already fired
 * from index.html on first load, so we skip the first render to avoid a double
 * count. Mount once near the router root — covers every page incl. the dashboard.
 */
export function RouteAnalytics() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    trackPageView();
  }, [pathname]);

  return null;
}
